module.exports = __webpack_public_path__ + "img/107025.98239472.png";